import { FC, useLayoutEffect } from 'react'
import { GalleryStagingFlowContextProvider, GalleryStagingFlowListContextProvider, GalleryStagingFlowStackProvider, GalleryStagingVisualSelectionProvider, GalleryUpsellProductsContextProvider } from 'components/pages/Gallery/pages/GalleryStagingFlow/_main/contexts'
import { useNavigate, useParams } from 'react-router-dom'

import { AssignmentDTO } from 'models/assignment'
import { GalleryStagingFlowController } from 'components/pages/Gallery/pages/GalleryStagingFlow/_main/GalleryStagingFlow.controller'
import { Path } from 'constants/router'
import { PropertyTab } from '../contexts'

/**
 * @interface Props for the ClientPropertyGalleryStagingFlowPage page.
 */
interface Props {
  /** Staging assignments */
  stagingAssignments: AssignmentDTO[]
}

export const ClientPropertyGalleryStagingFlowPage: FC<Props> = ({ stagingAssignments }) => {
  const navigate = useNavigate()
  const { id = '', assignmentId = '' } = useParams<{ id?: string, assignmentId?: string }>()

  // edge case - Redirect to property gallery if no staging assignments found.
  useLayoutEffect(() => {
    if (stagingAssignments.length === 0) {

      navigate(Path.PROPERTY_TAB_ASSIGNMENT
        .replace(':id', id)
        .replace(':tab', PropertyTab.GALLERY)
        .replace(':assignmentId', assignmentId))
    }
    // No all deps needed, it should trigger only on the first render
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assignmentId])

  return (
    <GalleryStagingVisualSelectionProvider>
      <GalleryUpsellProductsContextProvider assignmentId={stagingAssignments[0]?.id}>
        <GalleryStagingFlowStackProvider>
          <GalleryStagingFlowContextProvider>
            <GalleryStagingFlowListContextProvider>

              <GalleryStagingFlowController />

            </GalleryStagingFlowListContextProvider>
          </GalleryStagingFlowContextProvider>
        </GalleryStagingFlowStackProvider>
      </GalleryUpsellProductsContextProvider>
    </GalleryStagingVisualSelectionProvider>
  )
}
